// React
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'redux'

// Components
import FocalImage from 'ui/components/FocalImage'
import ReadOnlyModeDisabledComponent from 'store/components/ReadOnlyModeDisabledComponent'

// Shared
import Format from 'shared/utils/format'
import { withTranslation } from 'shared/utils/withTranslation'

export class EmbeddableCartLine extends Component {
  static displayName = 'EmbeddableCartLine'

  static propTypes = {
    line: PropTypes.object,
    currency: PropTypes.any,
    photo: PropTypes.object,
    useAvailability: PropTypes.bool,
    showPrices: PropTypes.bool,
    hideProductAvailabilityQuantities: PropTypes.bool,
    hasDates: PropTypes.bool,
    quantity: PropTypes.number,
    deleting: PropTypes.bool,
    onIncreaseQuantity: PropTypes.func,
    onDecreaseQuantity: PropTypes.func,
    onRemove: PropTypes.func,
    onInputChange: PropTypes.func,
    t: PropTypes.func
  }

  render () {
    const {
      line,
      currency,
      useAvailability,
      showPrices,
      hideProductAvailabilityQuantities,
      hasDates,
      quantity,
      deleting,
      onIncreaseQuantity,
      onDecreaseQuantity,
      onRemove,
      onInputChange,
      t
    } = this.props

    const available = line.available_quantity >= quantity
    const statusClass = available ? 'bq-available' : 'bq-unavailable'
    const titleClass = useAvailability ? 'bq-small' : 'bq-large'

    if (line.product_type === 'service' || line.quantity === 0) {
      return null
    }

    return (
      <tr key={line.id} className="bq-cart-item">
        <td>
          <div className="bq-product-photo">
            {line?.photo && (
              <div>
                <FocalImage
                  size="40px"
                  preview={line.photo.preview}
                  url={line.photo.large_url}
                  coordinates={line.photo.coordinates}
                  maintainAspect
                />
              </div>
            )}
            {!line?.photo && (
              <span className="bq-no-photo">
                <i className="bq-no-photo bq-icon-image fas fa-image" />
              </span>
            )}
          </div>
          <div className="bq-product-info">
            <div className={`bq-product-name ${titleClass}`}>{line.title}</div>
            {hasDates && useAvailability && (
              <span className={`bq-status-indicator ${statusClass}`}>
                {!hideProductAvailabilityQuantities && (
                  <Fragment>
                    <span className="bq-status-quantity">{line.available_quantity} </span>
                    {t('user.store.available')?.toLowerCase?.()}
                  </Fragment>
                )}
                {hideProductAvailabilityQuantities && (
                  t(available ? 'user.store.available' : 'user.store.unavailable')
                )}
              </span>
            )}
          </div>
        </td>
        <td>
          <ReadOnlyModeDisabledComponent>
            <div className={`bq-quantity ${deleting ? 'disabled' : 'enabled'}`}>
              <button className="bq-quantity-toggle" onClick={onDecreaseQuantity}>
                <i className="far fa-minus" />
              </button>
              <input
                type="number"
                className="bq-quantity"
                name="quantity"
                id="quantity"
                value={quantity}
                onChange={onInputChange}
              />
              <button className="bq-quantity-toggle" onClick={onIncreaseQuantity}>
                <i className="far fa-plus" />
              </button>
            </div>
          </ReadOnlyModeDisabledComponent>
        </td>
        <td className="bq-cart-total">
          {showPrices && line.display_price_in_cents > 0 && (
            <span className="bq-price">{Format.money(line.display_price_in_cents, currency)}</span>
          )}
        </td>
        <td>
          <ReadOnlyModeDisabledComponent>
            <button className="bq-remove-product" onClick={deleting ? undefined : onRemove}>
              <i className="bq-icon-cross fas fa-times" />
            </button>
          </ReadOnlyModeDisabledComponent>
        </td>
      </tr>
    )
  }
}

const mapStateToProps = (state) => ({ hideProductAvailabilityQuantities: state.settings.get('store.hide_product_availability_quantities') })

const EnhancedEmbeddableCartLine = compose(
  withTranslation('user'),
  connect(mapStateToProps)
)(EmbeddableCartLine)

export default EnhancedEmbeddableCartLine
